export const ko = {
    'generator-title-apa6' : 'APA 6 출처 생성기',
    'generator-title-apa7' : 'APA 7 출처 생성기',
    'generator-title-mla7' : 'MLA 7 출처 생성기',
    'generator-title-mla8' : 'MLA 8 출처 생성기',
    'generator-title-chicago' : 'Chicago 출처 생성기',
    'generator-title-vancouver' : 'Vancouver 출처 생성기',
    'generator-description-apa6' : 'Generate FREE APA 6th and 7th edition citations. Books, journals, and online sources. Copy citations directly to your reference list. Easy to use and ad-free!',
    'generator-description-apa7' : 'Generate FREE APA 6th and 7th edition citations. Books, journals, and online sources. Copy citations directly to your reference list. Easy to use and ad-free!',
    'generator-description-mla7' : 'Generate FREE MLA 7th and 8th edition citations. Books, journals, and online sources. Copy citations directly to your Works Cited. Easy to use and ad-free!',
    'generator-description-mla8' : 'Generate FREE MLA 7th and 8th edition citations. Books, journals, and online sources. Copy citations directly to your Works Cited. Easy to use and ad-free!',
    'generator-description-chicago' : 'Generate FREE Chicago Manual of Style (17th edition) citations. Books, journals, and online sources. Copy citations directly to your reference list.',
    'generator-description-vancouver' : 'Generate FREE Vancouver Style citations. Books, journals, and online sources. Copy citations directly to your reference list. Easy to use!',
    'Brand Name' : '에세이리뷰',
    'Citation Generator' : '출처 생성기',
    'Contributors': '저자',
    'Page Name' : '페이지명',
    'Site Name' : '웹사이트명',
    'Date Published' : '출판일자',
    'Date Accessed' : '접속일자',
    'Publisher' : '발행처',
    'Publisher Name' : '발행처 이름',
    'Publication Info' : '발행 관련 정보',
    'Publication Location' : '발행지',
    'Publication Year' : '발행 연도',
    'Day' : '일',
    'Month' : '월',
    'Year' : '연도',
    'Generate' : '출처 생성하기',
    'button_generate' : '출처 생성하기',
    'Copied.' : '복사완료.',
    'copied_messgage' : '복사되었습니다.',
    'generate_result' : '생성 결과',
    'Article Title' : '논문명',
    'Journal Title' : '저널명',
    'Edition' : '판',
    'Volume' : '권',
    'Issue' : '호',
    'Number' : '번호',
    'Pages' : '페이지 구간',
    'Website or Database Title' : '웹사이트명 혹은 데이터베이스명',
    'Title' : '표제',
    'Location' : '출판',
    'cite-Source' : '자료 형태',
    'cite-Style' : '스타일',
    'Copy' : '복사하기',
    'Delete' : '삭제하기',
    'Number or name' : '숫자 혹은 이름',
    'source-Website' : '웹사이트',
    'source-Journal Article' : '저널',
    'source-Book' : '단행본',
    'site_desc' : '인용 스타일 가이드를 선택하여 출처를 생성하세요.',
    'Example' : '예시',
    'Format' : '출처 표기 방법',
    'Citation Style Guides' : '스타일 인용 가이드',
    'Citation result.' : '출처 결과',
    'Page Title' : '페이지명',
    'Author Last Name' : '저자의 성',
    'Author First Name' : '저자의 이름',
    'Author First Initial' : '저자의 이름 이니셜',
    'Author Middle Name' : '저자의 가운데 이름',
    'Author Middle Initial' : '저자의 가운데 이름 이니셜',
    'Website Name' : '웹사이트명',
    'Print' : '인쇄물',
    'Digital' : '디지털',
    'Published Year' : '출판 연도',
    'Published Date' : '출판 일자',
    'citation-desc' : "원하는 스타일 가이드를 선택하고 필요한 출처 정보를 모두 입력하세요. 참고문헌용 출처 표기를 생성하려면  “출처 생성하기“를 클릭하세요. 출처는 출처생성기 아래에 생성됩니다. 출처를 본인의 참조문헌(References) 페이지에 복사해서 붙여넣으세요. 이미 생성된 출처를 목록에서 삭제할 수도 있습니다.",
    'author' : '저자',
    'editor' : '에디터',
    'translator' : '번역가',
    'First Name' : '이름',
    'Middle' : '가운데 이름',
    'Last Name' : '성',
    'Quick Guides' : '인용 스타일 가이드',
    'APA Citation Guide' : 'APA 스타일 인용 가이드',
    'MLA Citation Guide' : 'MLA 스타일 인용 가이드',
    'Chicago Citation Guide' : '시카고 스타일 인용 가이드',
    'Vancouver Citation Guide' : '밴쿠버 스타일 인용 가이드',
    'Style Guide Introduction' : '스타일 가이드 소개',

    "apa" : {
        "page-title" : "APA 출처 생성기",
        "page-description" : "APA 스타일은 사회과학, 행동과학, 경영학, 간호학에 종사하는 연구자와 학생들이 자주 사용합니다. APA 출처 생성기는 자동으로 APA 6 및 APA 7 형식의 출처와 텍스트 내 인용을 생성합니다. APA 출처 및 텍스트 내 인용 규칙에 대한 설명은 하단의 APA 인용 지침을 읽어보시기 바랍니다.",
        "meta-title" : "APA 출처/인용 생성기(양식변환, 표기법)",
        "meta-description" : "무료로 APA 6th / 7th 인용 스타일을 만들어보세요. 저널, 단행본, 웹사이트 등 여러 형태의 출처를 자동으로 생성해줍니다.",
    },

    "mla" : {
        "page-title" : "MLA 출처 생성기",
        "page-description" : "MLA 스타일은 문화 연구, 영어, 문학 및 비평 이론과 같은 인문학 분야의 원고 및 연구 논문을 준비하는 저자와 학생들이 사용하고 있습니다. MLA 출처 생성기는 자동으로 MLA 7 및 MLA 8 스타일에 대한 출처 및 텍스트 내 인용을 생성합니다. MLA 출처 및 텍스트 내 인용 규칙에 대한 설명은 하단의 MLA 인용 지침을 읽어보시기 바랍니다.",
        "meta-title" : "MLA 출처/인용 생성기(양식변환, 표기법)",
        "meta-description" : "무료로 MLA 7th / 8th 인용 스타일을 만들어보세요. 저널, 단행본, 웹사이트 등 여러 형태의 출처를 자동으로 생성해줍니다.",
    },

    "chicago" : {
        "page-title" : "Chicago 출처 생성기",
        "page-description" : "Chicago 스타일은 예술, 인문학 및 사회 과학 분야의 학술 논문에 사용되고 있습니다. Chicago 출처 생성기는 자동으로 Chicago 형식의 출처 및 텍스트 내 인용을 생성합니다. Chicago 출처 및 텍스트 내 인용 규칙에 대한 설명은 하단의 Chicago 인용 지침을 읽어보시기 바랍니다.",
        "meta-title" : "Chicago 출처/인용 생성기(양식변환, 표기법)",
        "meta-description" : "무료로 시카고 17th edition 인용 스타일을 만들어보세요. 학술지, 웹사이트 ,간행물 등 여러 형태의 출처를 자동으로 생성해줍니다.",
    },

    "vancouver" : {
        "page-title" : "Vancouver 출처 생성기",
        "page-description" : "Vancouver 스타일은 IEEE 및 MEDLINE을 포함한 과학 저널에서 사용되고 있습니다. 과학 저널에는 자체적으로 저자 지침이 있습니다. Vancouver는 형식 지정에 관계없이 저자-번호 시스템으로 지정되어 있습니다. Vancouver 출처 및 텍스트 내 인용 규칙에 대한 설명은 하단의 Vancouver 인용 지침을 읽어보시기 바랍니다.",
        "meta-title" : "Vancouver 출처/인용 생성기(양식변환, 표기법)",
        "meta-description" : "무료로 밴쿠버 2th edition 인용 스타일을 만들어보세요. 학술지, 웹사이트 ,간행물 등 여러 형태의 출처를 자동으로 생성해줍니다.",
    },

    // sidebar
    "Citation Sources" : "Citation Sources",
    "citation_sources" : {
        "link1" : {
            "uri" : "https://blog.essayreview.co.kr/youtube-video-citation-apa-mla-chicago-vancouver/",
            "title" : "유튜브 인용 방법",
        },
        "link2" : {
            "uri" : "https://blog.essayreview.co.kr/how-to-cite-images-apa-mla-chicago-vancouver/",
            "title" : "이미지 인용 방법",
        },
        "link3" : {
            "uri" : "https://blog.essayreview.co.kr/how-to-cite-movie-apa-mla-chicago-vancouver/",
            "title" : "영화 인용 방법",
        },
        "link4" : {
            "uri" : "https://blog.essayreview.co.kr/academic/how-to-cite-a-website-apa-mla-chicago-vancouver/",
            "title" : "웹사이트 인용 방법",
        },
        "link5" : {
            "uri" : "https://blog.essayreview.co.kr/academic/how-to-cite-a-podcast-apa-mla-chicago-vancouver/",
            "title" : "팟캐스트 인용 방법",
        },
        "link6" : {
            "uri" : "https://blog.essayreview.co.kr/academic/how-to-cite-chatgpt-sources-apa-mla-chicago-vancouver/",
            "title" : "ChatGPT 인용 방법",
        },
        "link7" : {
            "uri" : "https://blog.essayreview.co.kr/academic/how-to-cite-a-book-apa-mla-chicago-vancouver-style/",
            "title" : "책 인용 방법",
        },
    }
};



// WEBPACK FOOTER //
// ./src/lang/ko.js